import { a as r } from "../internals/array-buffer-view-core.js";
import { f as n } from "../internals/function-uncurry-this.js";
var a = r.aTypedArray,
  i = r.exportTypedArrayMethod,
  o = n([].join);
i("join", function (r) {
  return o(a(this), r);
});